function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

function jsonResponse(response) {
  return response.json();
}

function updateHeaders(response) {
  const userdata = {
    "email": response.headers.get('X-User-Email'),
    "token": response.headers.get('X-User-Token')
  }
  localStorage.setItem( 'userdata', JSON.stringify(userdata) )
  return response
}

export * from './accountsActions'

export * from './authActions'

export * from './entriesActions'

// export * from './feedsActions'

export * from './reportsActions'

export * from './preferencesActions'

export * from './scriptsActions'

export * from './usersActions'


export { checkStatus, updateHeaders, jsonResponse }



// WEBPACK FOOTER //
// ./src/js/actions/index.js